
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import desktopImageWebp from './images/non-qualified-retirement-plan-desktop.webp';
import mobileImageWebp from './images/non-qualified-retirement-plan-mobile.webp';
// low res images
import {
  lowResImageDesktop,
  lowResImageMobile,
}from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='non-qualified-retirement-plan'
      backgroundVariant='lightB'
      themeType='lightTheme'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Non&#45;Qualified Retirement Plan'
      headingText={<>An additional way to save <WidowBlock>for retirement.</WidowBlock></>}
      descriptionText='Help your key executives and select employees save for the retirement they want with less restrictions than traditional retirement plans.'
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Start planning',
        ariaLabel: 'Start planning with a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='Two coworkers sitting and speaking to one another at a desk'
      backgroundImageDesktop={desktopImageWebp.toString()}
      backgroundImageMobile={mobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
    />
  );};
